(function () {
  'use strict';
  
  angular.module(moduleConfig.applicationModuleName).constant('PCA_KEY_LOCAL', 'TP28-EG86-CG77-NW99');

  // bank-code mappings to bank-names
  angular.module(moduleConfig.applicationModuleName).constant('bankCodes', {
    '001':'BANK OF MONTREAL',
    '002':'THE BANK OF NOVA SCOTIA',
    '003':'ROYAL BANK OF CANADA',
    '004':'THE TORONTO-DOMINION BANK',
    '006':'NATIONAL BANK OF CANADA',
    '010':'CANADIAN IMPERIAL BANK OF COMMERCE',
    '016':'HSBC BANK CANADA',
    '030':'CANADIAN WESTERN BANK',
    '039':'LAURENTIAN BANK OF CANADA',
    '177':'BANK OF CANADA',
    '187':'CANADA SAVINGS BOND REDEMPTION CERT.',
    '219':'ALBERTA TREASURY BRANCHES',
    '220':'BC COMMUNITY FINANCIAL SERVICES CORP',
    '239':'PROVINCE OF ONTARIO SAVINGS OFFICE',
    '240':'ABN AMRO BANK CANADA',
    '241':'BANK OF AMERICA CANADA',
    '242':'MELLON BANK CANADA',
    '245':'BANK OF TOKYO-MITSUBISHI (CANADA)',
    '248':'BARCLAYS BANK OF CANADA',
    '249':'BANCA COMMERCIALE ITALIANA OF CANADA',
    '250':'BANQUE NATIONALE DE PARIS (CANADA)',
    '258':'CREDIT SUISSE FIRST BOSTON CANADA',
    '260':'CITIBANK CANADA',
    '265':'DEUTSCHE BANK CANADA',
    '267':'CREDIT LYONNAIS CANADA',
    '269':'INT\'L COMM BANK OF CATHAY (CANADA)',
    '270':'BANK ONE CANADA',
    '275':'KOREA EXCHANGE BANK OF CANADA',
    '277':'DAI-ICHI KANGYO BANK (CANADA)',
    '281':'JP MORGAN CANADA',
    '286':'NATIONAL BANK OF GREECE (CANADA)',
    '287':'NATIONAL WESTMINSTER BANK OF CANADA',
    '290':'UBS BANK (CANADA)',
    '292':'SOCIETE GENERALE (CANADA)',
    '294':'STATE BANK OF INDIA (CANADA)',
    '300':'TOKAI BANK CANADA',
    '301':'THE SUMITOMO BANK OF CANADA',
    '303':'AMEX BANK OF CANADA',
    '305':'SOTTOMAYOR BANK CANADA',
    '307':'THE BANK OF EAST ASIA (CANADA)',
    '308':'BANK OF CHINA (CANADA)',
    '309':'CITIZENS BANK OF CANADA',
    '310':'FIRST NATIONS BANK OF CANADA',
    '311':'MBNA CANADA BANK',
    '314':'Chase Manhattan Bank of Canada',
    '315':'CTC BANK OF CANADA',
    '321':'HABIB CANADIAN BANK',
    '322':'RABOBANK NETHERLANDS',
    '323':'CAPITAL ONE BANK (CANADA BRANCH)',
    '326':'AMICUS BANK',
    '327':'STATE STREET BANK & TRUST COMPANY',
    '328':'CITIBANK NA',
    '330':'COMERICA BANK CANADA BR',
    '332':'FIRST COMMERCIAL BANK',
    '334':'PACIFIC & WESTERN BANK OF CANADA',
    '335':'UNITED OVERSEAS BANK LTD',
    '338':'CANADIAN TIRE BANK',
    '340':'ICICI BANK CANADA',
    '342':'UBIQUITY BANK OF CANADA',
    '343':'DUNDEE WEALTH BANK',
    '346':'SOCIETE GENERALE(CANADA BR)',
    '347':'BRIDGEWATER BANK',
    '352':'DIRECTCASH BANK',
    '354':'JAMESON BANK',
    '355':'SHINHAN BANK CANADA',
    '361':'CFF BANK',
    '366':'CHINA CONSTRUCTION BANK',
    '369':'AMERICAN EXPRESS C$ TRAVELLERS CHQ',
    '506':'TRUST GENERAL INC',
    '507':'COMMUNITY TRUST COMPANY LTD',
    '509':'THE CANADA TRUST COMPANY',
    '522':'TRUST LA LAURENTIENNE',
    '532':'THE EFFORT TRUST COMPANY',
    '535':'HOME SAVINGS AND LOAN CORPORATION',
    '536':'INVESTORS GROUP TRUST CO. LTD.',
    '540':'MANULIFE BANK OF CANADA',
    '544':'MONTREAL TRUST COMPANY',
    '547':'MENNONITE TRUST LIMITED',
    '548':'CIBC TRUST CORPORATION',
    '550':'MONTREAL TRUST COMPANY OF CANADA',
    '551':'THE CLARICA TRUST COMPANY',
    '552':'HONGKONG BANK TRUST COMPANY',
    '554':'CITIZENS TRUST COMPANY',
    '560':'AGF TRUST COMPANY',
    '568':'PEACE HILLS TRUST COMPANY',
    '570':'ROYAL TRUST COMPANY (THE)',
    '574':'STANDARD TRUST COMPANY',
    '580':'ROYAL TRUST CORPORATION OF CANADA',
    '590':'NATIONAL TRUST COMPANY',
    '608':'CS ALTERNA BANK',
    '611':'LAURENTIAN BANK OF CANADA',
    '613':'TD TRUST COMPANY',
    '614':'ING BANK OF CANADA',
    '618':'B2B TRUST',
    '621':'PEOPLES TRUST COMPANY',
    '623':'EQUITABLE BANK',
    '626':'MANULIFE TRUST COMPANY',
    '630':'HOUSEHOLD TRUST COMPANY',
    '701':'EDWARD JONES',
    '802':'NEWTEL CREDIT UNION LIMITED',
    '803':'LATVIAN CREDIT UNION LIMITED',
    '804':'TORONTO FIRE DEPT EMPLOYEES CR UNION',
    '806':'DUCA COMMUNITY CREDIT UNION LIMITED',
    '807':'ONTARIO TELEPHONE EMPLOYEES CR UN',
    '808':'ARNSTEIN COMMUNITY CREDIT UNION LTD',
    '809':'POWELL RIVER CREDIT UNION',
    '810':'ALL TRANS CREDIT UNION LIMITED',
    '815':'F.C.P.D.',
    '819':'LA FED DES CAISSES POP DU MAN INC',
    '821':'ELECTRAGAS CREDIT UNION LTD',
    '828':'CREDIT UNION CENTRAL OF ONTARIO',
    '829':'C.P. ST-CHARLES D\'OTTAWA',
    '830':'AIRLINE (MALTON) CREDIT UNION',
    '831':'CHATHAM TOWN CREDIT UNION',
    '833':'ST STANISLAUS-ST CASIMIR\'S CR UN LTD',
    '834':'ASCU COMMUNITY CREDIT UNION LTD',
    '836':'LA CAISSE POPULAIRE DE KAPUSKASING',
    '837':'HEPCOE CREDIT UNION LIMITED',
    '839':'DOMINION CREDIT UNION LTD',
    '840':'DUNDALK DISTRICT CREDIT UNION LTD',
    '841':'CAISSE D\'ETABLISSEMENT RIVE-SUD',
    '842':'CIVIL SERVICE CO-OP CREDIT SOCIETY',
    '844':'GODERICH COMMUNITY CREDIT UNION LTD.',
    '846':'ONTARIO CIVIL SERVICE CR UN LTD',
    '848':'CBC (TORONTO) CREDIT UNION LIMITED',
    '849':'TRICO CREDIT UNION',
    '850':'POLYSAR LAMBTON CREDIT UNION LIMITED',
    '851':'HOLY FAMILY PARISH (BLIND RIVER) CR',
    '853':'CONCENTRA FINANCIAL SERVICES ASSOC',
    '854':'EMPLS OF DOFASCO(HAMILTON)CR UN LTD',
    '865':'CAISSE POPULAIRE ABOUJAGANE LIMITEE',
    '879':'GRETNA CREDIT UNION LIMITED',
    '889':'ABERNETHY CREDIT UNION LIMITED',
    '890':'L\'ALLIANCE DES C P DE L\'ONTARIO LTEE',
    '899':'CREDIT UNION CENTRAL ALBERTA LTD.'
  });







})();
